import React, { useState } from 'react';
import styled from 'styled-components';
import { CHART_PERIOD_LEVELS, CHART_PERIOD_LABELS } from '../common/enum';

interface Props {
  periodData: CHART_PERIOD_LEVELS[];
  activePeriod: number;
  onPeriodSelect: (period: CHART_PERIOD_LEVELS) => void;
}

const Container = styled.div`
  width: max-content;
  height: max-content;
  display: flex;
  justify-content: space-between;
  margin: 1.5rem auto 0 auto;
  border: 2.07px solid #e2e2e2;
  border-radius: 3.82px;
  overflow: hidden;
  @media screen and (max-width: 900px) {
    display: flex;
    width: max-content;
    margin: 1.5rem auto 0 auto;
    justify-content: center;
  }
`;

const RadioGroup = styled.div<{ isSelected: boolean }>`
  display: flex;
  justify-content: center;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 1rem;
  align-items: center;
  padding: 0.5rem 1rem;
  color: ${(props) => (props.isSelected ? '#75FFFF' : '#8C8C8C')};
  background-color: ${(props) =>
    props.isSelected ? '#001316' : 'transparent'};
  cursor: pointer;
  @media screen and (max-width: 900px) {
    padding: 0.5rem 0.5rem;
    width: max-content;
  }
`;

const RadioLabel = styled.label`
  cursor: pointer;
  text-align: center;
  letter-spacing: 0.2rem;
`;

export const PeriodChips: React.FC<Props> = ({
  periodData,
  activePeriod,
  onPeriodSelect,
}) => {
  const [selected, setSelected] = useState<CHART_PERIOD_LEVELS>(
    periodData[activePeriod],
  );

  const handleSelect = (period: CHART_PERIOD_LEVELS) => {
    setSelected(period);
    onPeriodSelect(period);
  };

  return (
    <Container>
      {periodData.map((period) => (
        <RadioGroup
          key={period}
          isSelected={selected === period}
          onClick={() => handleSelect(period)}
        >
          <RadioLabel>{CHART_PERIOD_LABELS[period]}</RadioLabel>
        </RadioGroup>
      ))}
    </Container>
  );
};
